import React from 'react';
const Logo = () => {
  return <div className="flex items-center" data-id="element-129">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-130">
        <circle cx="20" cy="20" r="20" fill="#E57C23" data-id="element-131" />
        <path d="M10 15H30M10 20H30M10 25H20" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-132" />
        <path d="M24 25C24 25 26 27 28 25C30 23 28 30 24 28C20 26 24 25 24 25Z" fill="#FFD28F" stroke="white" data-id="element-133" />
      </svg>
      <span className="ml-2 text-xl font-bold text-[#E57C23]" data-id="element-134">Realmpoint</span>
    </div>;
};
export default Logo;